// =================================================================
// Firebase initialization
//
// Initializes the Firebase app once and exports the auth and
// database handles for use throughout the Brain Health app.
//
// The config below is the Quiltt Games project's public config —
// the same one used by the games site. Firebase Web SDK configs
// are designed to be public; security comes from database rules,
// not from hiding the config.
// =================================================================

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey:            'AIzaSyBg1g1SalMLnjK1SmN2xSuEv4SB62XBTes',
  authDomain:        'quiltt-games.firebaseapp.com',
  databaseURL:       'https://quiltt-games-default-rtdb.firebaseio.com',
  projectId:         'quiltt-games',
  storageBucket:     'quiltt-games.firebasestorage.app',
  messagingSenderId: '1066107521556',
  appId:             '1:1066107521556:web:fe3d77f15ba8b97d12b501',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getDatabase(app);

// Super-admin email. This account has unrestricted access to all
// communities and residents. The same email is enforced by database
// rules — both client and server must agree, but the server is the
// load-bearing check.
//
// Community-scoped admins (activity directors, etc.) sign in with
// their own email and get access scoped to communities whose
// `contact_email` matches their address.
export const SUPER_ADMIN_EMAIL = 'fpeyerl@quiltt.com';
